export default {
  CalendarStrip__BUTTON_GROUP_NEXT: "Next",
  CalendarStrip__BUTTON_GROUP_PREVIOUS: "Previous",
};
